import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getArtifact, getArtifactGroups, getTombstonedArtifact } from '../../services/artifactService'
import useNotifications from '../useNotifications'

/**
 * Hook for fetching a specific artifact
 * @param {number} artifactId ID to fetch
 * @returns {Object} object with loading boolean, error status/data, artifact object, and refetch function
 */
const useArtifact = (artifactId, patronId) => {
  const { t } = useTranslation()
  const [artifact, setArtifact] = useState(null)
  const [refetch, setRefetch] = useState(true)
  const { error } = useNotifications()

  useEffect(() => {
    let promise = getArtifact(artifactId)
    if (patronId) {
      promise = getTombstonedArtifact(artifactId, patronId)
    }

    promise
      .then(async (response) => {
        const artifactData = { ...response.data }
        if (response.data.visibility === 'PRIVATE') {
          try {
            const artifactGroupData = await getArtifactGroups(response.data.id)
            artifactData.groupIds = artifactGroupData.data.groupIds
          } catch (err) {
            err.response?.status !== 403 &&
              error(t('hooks.errors.retrievingArtifactGroups', `Error retrieving artifact groups`), err)
          }
        }

        setArtifact(artifactData)
      })
      .catch((err) => {
        setArtifact(null)
        error(t('hooks.errors.retrievingArtifact', `Error retrieving artifact`), err)
      })
  }, [artifactId, refetch, patronId, error, t])

  const refetchArtifact = () => setRefetch(!refetch)

  return {
    artifact,
    refetchArtifact,
  }
}

export default useArtifact
